import { useQueries, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import {
  listContractors,
  listExpenses,
  listInsurancePolicies,
  listMaintenanceRequests,
  listProperties,
  listRentPayments,
  listRentalLicenses,
  listReminders,
  listTenants,
} from "@/services/dataService";

const SOURCES = {
  properties: listProperties,
  tenants: listTenants,
  expenses: listExpenses,
  rentPayments: listRentPayments,
  maintenance: listMaintenanceRequests,
  insurance: listInsurancePolicies,
  licenses: listRentalLicenses,
  contractors: () => listContractors(),
  reminders: listReminders,
};

/**
 * Load the owner's records the redesigned pages share. Pass the names you
 * need; each list is cached under ["portfolio", name, userId].
 */
export function usePortfolioData(names) {
  const { currentUser } = useAuth();
  const userId = currentUser?._id;
  const queryClient = useQueryClient();
  const results = useQueries({
    queries: names.map((name) => ({
      queryKey: ["portfolio", name, userId],
      queryFn: SOURCES[name],
      enabled: Boolean(userId),
    })),
  });
  const data = {};
  names.forEach((name, index) => {
    data[name] = results[index].data || [];
  });
  return {
    data,
    isLoading: results.some((result) => result.isLoading),
    error: results.find((result) => result.error)?.error || null,
    refresh: () => queryClient.invalidateQueries({ queryKey: ["portfolio"] }),
  };
}
